import React from "react";
import PrivacyWrap from "./PrivacyWrap";

function Privacy(props) {
    return (
        <>
            <PrivacyWrap/>
        </>
    )
}

export default Privacy;
